export default __webpack_public_path__ + "static/media/food.5b24f818.svg";